import { Component, OnInit } from '@angular/core';
import { Parameter} from '../../../_models/parameter';
import * as fromParameter from '../../../parameter/state/parameter.reducer';
import * as parameterActions from '../../../parameter/state/parameter.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  templateUrl: './parameter-shell.component.html'
})

export class ParameterShellComponent implements OnInit {

    parameters$: Observable<Parameter[]>;
    currentParameter$: Observable<Parameter>;

  constructor(
    private store: Store<fromParameter.State>
  ) {
    this.store.dispatch( new parameterActions.LoadParameters({setup_user: 'Cut'}));
  }

  ngOnInit() {
    this.parameters$ = this.store.pipe(select(fromParameter.getParameterList)) as Observable<Parameter[]>;
  }

  updateParameter(parameter: Parameter | null): void {

    console.log('---> selectParameter parameterIn ');
    console.log(parameter);

    this.store.dispatch( new parameterActions.SetCurrentParameter(parameter));
    this.store.dispatch((new parameterActions.UpdateParameter(parameter)));

  } // End function selectParameter

} // End class ParameterShellComponent
